import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { UcatLayout } from "../../Components/Shared";
import { ArrowRight } from "lucide-react";
import useNavigationBlocker from "../../../../Hooks/useNavigationBlocker";

export const EndExamScreen = () => {
  useNavigationBlocker(true);
  const navigate = useNavigate();
  const location = useLocation();
  const endNavPath = location.state?.endNavPath ?? "/ucat_test";
  const renderFor = location.state?.renderFor ?? "exam";
  const headerTitle = location.state?.headerTitle ?? "UCAT Exam";

  const handleEnd = () => {
    navigate(endNavPath);
  };

  return (
    <UcatLayout
      headerTitle={headerTitle}
      showToolbar={true}
      footerProps={{
        onEndExam: handleEnd,
        leftButtonText: `End ${renderFor.slice(0, 1).toUpperCase() + renderFor.slice(1)}`,
      }}
    >
      <div className="flex-1 h-0 min-h-0 w-full overflow-y-auto p-0 flex flex-col bg-white ucat-scrollbar">
        {/* Content Container */}
        <div className="p-8 text-black">
          <h1 className="text-[16px] font-bold text-left mb-6 f-tahoma">
            {headerTitle}
          </h1>

          <div className="space-y-4 f-tahoma text-[16px]">
            <p className="f-tahoma text-[14px]">
              You have completed the {headerTitle} {renderFor.slice(0, 1).toUpperCase() + renderFor.slice(1)}.
            </p>
            <p className="f-tahoma text-[14px]">
              Please click on the <span className="font-bold text-[14px]">{`End ${renderFor.slice(0, 1).toUpperCase() + renderFor.slice(1)}`}</span> button.
            </p>
          </div>
        </div>
      </div>
    </UcatLayout>
  );
};

export default EndExamScreen;
